// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__2Dw9r","logo":"Toolbar_logo__3E-23","desktopOnly":"Toolbar_desktopOnly__InZBY"};